import { GoabModal, GoabButtonGroup, GoabButton } from "@abgov/react-components";
import { useSessionManagement } from "../../ServiceUtils/useSessionManagement";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
 
interface SignoutModalProps {
    showModal?: boolean;
  }

export const SignoutModal = ({ showModal }: SignoutModalProps) => {
  const [show, setShow] = useState<boolean>(showModal ?? false);
  const { getResourceValue } = useSessionManagement();
  const navigate = useNavigate();

  return (
    <GoabModal
      testId="logout--modal"
      calloutVariant="success"
      role="alertdialog"
      open={show}
      maxWidth="480px"
      heading={getResourceValue({ key: "RESOURCES@global.logoutmessage" })}
      actions={
        <GoabButtonGroup alignment="end">
          <GoabButton
            type="primary"
            testId="logout-okay-button"
            onClick={() => { setShow(false); navigate('/') }}
          >
            {getResourceValue({ key: "RESOURCES@global.okay" })}
          </GoabButton>
        </GoabButtonGroup>
      }
      />
  );
};
